import React from 'react'

import { Wrapper } from './FileContents.styles'
import { NO_CONTENTS_MESSAGE } from './utils'

export const NoContent = () => {
  return (
    <Wrapper>
      <pre>{NO_CONTENTS_MESSAGE}</pre>
    </Wrapper>
  )
}
